import React, { useEffect, useState } from "react";
import { Showroom2D, Showroom3D } from "../../constants/rowData.constants";
import SelectedCarBlock from "../../components/selectedCarBlock";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveUrl,
  setShowRoom,
  setTitle,
  setZoomModelVisibility,
} from "../../redux/slices/carrommSlice";
import { useCarromm } from "../../context/carromm";
import Carousel, { consts } from "react-elastic-carousel";
import UpArrow from "../../components/icons/UpArrow";
import DownArrow from "../../components/icons/DownArrow";
import Heading from "../../components/heading/Heading";

const Windows = () => {
  const { dimension } = useSelector((state) => state.carromm);

  const [showroomImages, setShowroomImages] = useState(
    dimension === "2D" ? Showroom2D : Showroom3D
  );
  const carrom = useCarromm();
  const dispatch = useDispatch();
  let target = dimension === "2D" ? { target: "background" } : {};

  const handleSelectBackground = (item) => {
    setShowroomImages(
      showroomImages.map((t) => ({ ...t, isSelected: t.id === item.id }))
    );
    dispatch(setShowRoom(item.id));
    dispatch(setActiveUrl(item?.thumbnail));
    dispatch(setTitle(item?.title || null));
  };
  const handleNext = () => {
    carrom.setTabs(
      carrom.tabs.map((t) => ({ ...t, active: t.id === "number-plate" }))
    );
  };

  const arrowButtons = ({ type, onClick, isEdge }) => {
    const pointer = type === consts.PREV ? <UpArrow /> : <DownArrow />;
    return (
      <button onClick={onClick} disabled={isEdge} className="arrow-btn">
        {pointer}
      </button>
    );
  };

  return (
    <>
      <Heading />
      <div className="select-background-block">
        <div className="bg-list">
          <div></div>
          <ul id="scroll">
            <Carousel verticalMode itemsToShow={4} renderArrow={arrowButtons}>
              {showroomImages &&
                Array.isArray(showroomImages) &&
                showroomImages?.map((item, index) => (
                  <li
                    key={item?.id || index}
                    className={item.isSelected ? "selected-bg" : "hover-class"}
                    style={{ cursor: "pointer" }}
                    title="Double click to zoom"
                    onClick={() => handleSelectBackground(item)}
                    onDoubleClick={() => {
                      dispatch(setZoomModelVisibility(true));
                    }}
                  >
                    <img src={item?.thumbnail} alt={item?.thumbnail} />
                    {item?.title && (
                      <p className="background-title">{item?.title}</p>
                    )}
                  </li>
                ))}
            </Carousel>
          </ul>
          <div></div>
        </div>
        <SelectedCarBlock handleNext={handleNext} {...target} />
      </div>
    </>
  );
};

export default Windows;
